import React, { useState } from 'react';
export const PasswordProtect = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === 'race2026') {
      setIsAuthenticated(true);
      setError(false);
    } else {
      setError(true);
      setPassword('');
    }
  };
  if (isAuthenticated) {
    return <>{children}</>;
  }
  return <div className="min-h-screen bg-[#F8F5EE] flex flex-col items-center justify-center px-6" data-id="element-94" data-mp="2fnchwm5k20gm">
      <div className="w-full max-w-md bg-white p-8 rounded-2xl shadow-xl border border-gray-200" data-id="element-95" data-mp="2apu8yvrjfl8m">
        <div className="mb-8 text-center" data-id="element-96" data-mp="25savvz6ktei9">
          <h1 className="text-3xl font-bold text-[#070707] mb-2 tracking-tight" data-id="element-97" data-mp="21pe87u26is7g">
            Staging Area
          </h1>
          <p className="text-gray-500" data-id="element-98" data-mp="1wqukpp7xt8cz">
            Please enter the password to continue.
          </p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-6" data-id="element-99" data-mp="7aymsxkem24u">
          <div data-id="element-100" data-mp="c3rrxmjsbchg">
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent transition-all" autoFocus data-id="element-101" data-mp="c49ut20ycoyc" />
            {error && <p className="mt-2 text-sm text-red-600 font-medium" data-id="element-102" data-mp="v0syvcwwfmo1">
                Incorrect password. Please try again.
              </p>}
          </div>
          <button type="submit" className="w-full bg-red-600 text-white font-semibold py-3 px-4 rounded-lg hover:bg-red-700 transition-colors" data-id="element-103" data-mp="m0wevolgfbzb">
            Enter
          </button>
        </form>
      </div>
    </div>;
};